import React from 'react';
import { Search, X } from 'lucide-react';
import { Input } from '@/components/ui/input';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';

export default function ListToolbar({ search, onSearchChange, statusValue, statusOptions, onStatusChange, right, placeholder = 'Search…', testIdPrefix = 'list' }) {
  return (
    <div className="flex flex-col sm:flex-row sm:items-center gap-3 mb-4">
      <div className="relative flex-1 max-w-md">
        <Search className="w-4 h-4 absolute left-3 top-1/2 -translate-y-1/2 text-zinc-400" strokeWidth={1.75} />
        <Input
          value={search}
          onChange={(e) => onSearchChange(e.target.value)}
          placeholder={placeholder}
          className="pl-9 h-10 border-zinc-200"
          data-testid={`${testIdPrefix}-search-input`}
        />
        {search && (
          <button onClick={() => onSearchChange('')} className="absolute right-2 top-1/2 -translate-y-1/2 p-1 rounded hover:bg-zinc-100" data-testid={`${testIdPrefix}-search-clear`}>
            <X className="w-3.5 h-3.5 text-zinc-500" />
          </button>
        )}
      </div>
      {statusOptions && (
        <Select value={statusValue || 'ALL'} onValueChange={(v) => onStatusChange(v === 'ALL' ? '' : v)}>
          <SelectTrigger className="w-40 h-10 border-zinc-200" data-testid={`${testIdPrefix}-status-filter`}>
            <SelectValue placeholder="All statuses" />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="ALL">All statuses</SelectItem>
            {statusOptions.map((s) => (
              <SelectItem key={s} value={s}>{s}</SelectItem>
            ))}
          </SelectContent>
        </Select>
      )}
      {right && <div className="sm:ml-auto flex items-center gap-2">{right}</div>}
    </div>
  );
}
